import React, { useState, useEffect } from 'react'
import { Button, Checkbox } from '@material-ui/core'

import ParagonTable from '../table/ParagonTable'
import BringgTable from '../table/BringgTable'

import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import MomentUtils from '@date-io/moment'
import moment from 'moment'
import 'moment-timezone'



import './app.scss'
import branchData from '../../branches.json'
import { filterClosed } from "../../selectors/records"



const BRANCH_ID =
  new URLSearchParams(window.location.search)
    .get('branchId')
    ?.substr(2)


    function getBringgDeliveryWindow(showPrevious) {
      const tz = "Europe/London"
      let end = moment.tz(tz)
    
      // End of window is always today at 21:00
      end.hour(21).minute(0).second(0)
    
      // If current time is before 21:00, end is today 21:00 (future),
      // which is fine — we still compare <= end
      let start = end.clone()
    
      // Move start to previous working day 21:00
      do {
        start.subtract(1, 'day')
      } while (start.isoWeekday() > 5) // skip Sat/Sun
    
      // If "Show Previous Delivery Day’s" is ON,
      // move one more working-day window back
      if (showPrevious) {
        end = start.clone()
        do {
          start = start.clone().subtract(1, 'day')
        } while (start.isoWeekday() > 5)
      }
    
      return { start, end }
    }
    
    

function App () {
  const [paragonRecords, setParagonRecords] = useState([])
  const [bringgRecords, setBringgRecords] = useState([])

 
  const [branchSource, setBranchSource] = useState(null)
  const [viewMode, setViewMode] = useState("PARAGON")

  // Paragon → Show Closed
  // Bringg  → Show Past Orders
  const [showClosed, setShowClosed] = useState(false)

  // Bringg-only UI
  const [groupByDriver, setGroupByDriver] = useState(false)

  // Loading gate (prevents flicker)
  const [loading, setLoading] = useState(true)

  const [selectedDate, setSelectedDate] = useState(
    moment().subtract(process.env.REACT_APP_DEFAULT_DAYS_AGO, 'days')
  )

  // useEffect(() => {
  //   fetchAndSetData()
  // }, [])

 
  
  // async function fetchAndSetData() {
  //   console.log("fetchAndSetData called")
  //   setLoading(true)
  
  //   try {
  //     const data = await fetchData()
  //     console.log("API DATA:", data)
  
  //     const para = data.paragonDeliveryStatus || []
  //     const bringg = data.bringgDeliveryStatus || []
  
  //     setParagonRecords(para)
  //     setBringgRecords(bringg)
  
  //     if (para.length > 0 && bringg.length > 0) {
  //       setBranchSource("HYBRID")
  //       setViewMode("PARAGON")
  //     } else if (bringg.length > 0) {
  //       setBranchSource("BRINGG")
  //     } else {
  //       setBranchSource("PARAGON")
  //     }
  //   } catch (err) {
  //     console.error("API FAILED:", err)
  //   } finally {
  //     setLoading(false)
  //   }
  // }
  
  useEffect(() => {
    
    fetchAndSetData(false)
  
    const interval = setInterval(() => {
      fetchAndSetData(true) 
    }, 30000)
  
    return () => clearInterval(interval)
  }, [])

  async function fetchAndSetData(isAutoRefresh = false) {
  console.log("fetchAndSetData called")

  if (!isAutoRefresh) {
    setLoading(true)
  }

  try {
    const data = await fetchData()

    const para = data.paragonDeliveryStatus || []
    const bringg = data.bringgDeliveryStatus || []

    // Always update data
    setParagonRecords(para)
    setBringgRecords(bringg)

    
    // if (!isAutoRefresh) {
    //   if (para.length > 0 && bringg.length > 0) {
    //     setBranchSource("HYBRID")
    //     setViewMode("PARAGON")
    //   } else if (bringg.length > 0) {
    //     setBranchSource("BRINGG")
    //   } else {
    //     setBranchSource("PARAGON")
    //   }
    // }

    if (!isAutoRefresh) {
      if (para.length > 0 && bringg.length > 0) {
        setBranchSource("HYBRID")
    
        const latestParagon = Math.max(
          ...para.map(r => new Date(r.timestamp || 0).getTime())
        )
    
        const latestBringg = Math.max(
          ...bringg.map(r => new Date(r.timestamp || 0).getTime())
        )
    
        if (latestBringg > latestParagon) {
          setViewMode("BRINGG")
        } else {
          setViewMode("PARAGON")
        }
    
      } else if (bringg.length > 0) {
        setBranchSource("BRINGG")
      } else {
        setBranchSource("PARAGON")
      }
    }
  } catch (err) {
    console.error("API FAILED:", err)
  } finally {
    if (!isAutoRefresh) {
      setLoading(false)
    }
  }
}
  async function fetchData() {
    const df = moment()
      .subtract(4, 'days')
      .startOf('day')
      .format("YYYY-MM-DDTHH:mm:ss[Z]")
  
    console.log("CALLING API WITH:", df)
  
    const res = await fetch(
      `${process.env.REACT_APP_DELIVERY_STATUS_API}/updates?branchId=${BRANCH_ID}&dateFilter=${df}`
    )
  
    console.log("STATUS:", res.status)
  
    return res.json()
  }
  
  
  
  function getBranchHeader() {
    const branch = branchData.find(b => b.branchId === parseInt(BRANCH_ID))
    return branch ? branch.branchName : ""
  }

  function filterByDate(records) {
    const from = selectedDate.clone().startOf('day')
    return records.filter(r =>
      r.timestamp && moment(r.timestamp).isSameOrAfter(from)
    )
  }

  // function filterBringgByDay(records, showPastOrders) {
  //   const start = moment().subtract(1, 'day').hour(21).minute(0).second(0)
  //   return records.filter(r => {
  //     if (!r.timestamp) return false
  //     const ts = moment(r.timestamp)
  //     return showPastOrders ? ts.isBefore(start) : ts.isSameOrAfter(start)
  //   })
  // }

  function filterBringgByDay(records, showPrevious) {
    const { start, end } = getBringgDeliveryWindow(showPrevious)
  
    return records.filter(r => {
      if (!r.timestamp) return false
      const ts = moment.utc(r.timestamp).tz("Europe/London")

      return ts.isSameOrAfter(start) && ts.isBefore(end)
    })
  }
  

  
  
  
  const isBringgView =
    branchSource === "BRINGG" ||
    (branchSource === "HYBRID" && viewMode === "BRINGG")

    const recordsToShow = isBringgView
    ? filterBringgByDay(bringgRecords, showClosed)
    : filterByDate(filterClosed(paragonRecords, showClosed))
  


  if (loading) {
    return (
      <main>
        <div className="container" />
      </main>
    )
  }

  return (
    <main>
      <div className="container">

        {/* HEADER */}
        <div className="header">
          <div className="headers">
          <h1>
  {isBringgView
    ? "Live Delivery Tracker"
    : "Home Delivery Bag Status Report"}
</h1>
            <h3>{getBranchHeader()}</h3>

            {/* Bringg info text */}
            {isBringgView && (
              <div className="bringg-info">
                This tracker will display all orders assigned to a driver for your
                Pharmacy for <strong>CURRENT DAY</strong>
              </div>
            )}
          </div>

          <div className="print">
            <Button variant="contained" onClick={() => window.print()}>
              Print Status Report
            </Button>
          </div>
        </div>

        {/* CONTROLS */}
        <div className="controls">

          {/* Date picker — Paragon only */}
          {!isBringgView && (
            <MuiPickersUtilsProvider utils={MomentUtils}>
              <KeyboardDatePicker
                disableFuture
                value={selectedDate}
                onChange={setSelectedDate}
                autoOk
                format="DD/MM/YYYY"
                label="Date From"
              />
            </MuiPickersUtilsProvider>
          )}

          {/* Bringg controls */}
          {isBringgView && (
            <div className="bringg-controls-row">
              <div className="filter__closed">
                <span>Show Previous Delivery Day</span>
                <Checkbox
                  color="default"
                  checked={showClosed}
                  onChange={e => setShowClosed(e.target.checked)}
                />
              </div>

              <div className="group-by-driver">
                <span>Group by Driver</span>
                <Checkbox
                  color="default"
                  checked={groupByDriver}
                  onChange={e => setGroupByDriver(e.target.checked)}
                />
              </div>
            </div>
          )}

          {/* Paragon controls */}
          {!isBringgView && (
            <>
              <div className="filter__closed">
                <span>Show Closed</span>
                <Checkbox
                  checked={showClosed}
                  onChange={e => setShowClosed(e.target.checked)}
                />
              </div>

              <div className="refresh">
                <Button
                  variant="contained"
                  onClick={(fetchAndSetData)}
                >
                  Refresh
                </Button>
              </div>
            </>
          )}
        </div>

        {/* HYBRID TOGGLE */}
        {branchSource === "HYBRID" && (
          <div style={{ marginBottom: 16 }}>
            <Button
              variant={viewMode === "PARAGON" ? "contained" : "outlined"}
              onClick={() => setViewMode("PARAGON")}
            >
              Flexipod
            </Button>

            <Button
              style={{ marginLeft: 8 }}
              variant={viewMode === "BRINGG" ? "contained" : "outlined"}
              onClick={() => setViewMode("BRINGG")}
            >
              Bringg
            </Button>
          </div>
        )}

        {/* TABLES */}
        {branchSource === "PARAGON" && (
          <ParagonTable updates={recordsToShow} />
        )}

        {branchSource === "BRINGG" && (
          <BringgTable
            updates={recordsToShow}
            groupByDriver={groupByDriver}
          />
        )}

        {branchSource === "HYBRID" && viewMode === "PARAGON" && (
          <ParagonTable updates={recordsToShow} />
        )}

        {branchSource === "HYBRID" && viewMode === "BRINGG" && (
          <BringgTable
            updates={recordsToShow}
            groupByDriver={groupByDriver}
          />
        )}

      </div>
    </main>
  )
}

export default App
